import { useReducer, useEffect } from "react";
/* eslint-disable */

const useForm = callback => {
  //State
  const initState = {
    input: {
      username: "",
      password: ""
    },
    validationErrs: {
      username: "",
      password: ""
    },
    isSubmiting: false
  };

  // Reducer
  const reducer = (state, action) => {
    switch (action.type) {
      case "INPUT_CHANGE":
        return {
          ...state,
          input: {
            ...state.input,
            ...action.payload
          },
          validationErrs: {
            ...state.validationErrs,
            ...validateOnTouch(state, action)
          }
        };
      case "SUBMIT":
        return {
          ...state,
          validationErrs: {
            username: "",
            password: "",
            ...validateOnSubmit(state)
          },
          isSubmiting: true
        };
      case "STOP_SUBMIT":
        return {
          ...state,
          isSubmiting: false
        };
      default:
        return state;
    }
  };
  const [state, dispatch] = useReducer(reducer, initState);

  const OnLoadForm = (key, value) => {
    dispatch({
      type: "INPUT_CHANGE",
      payload: { [key]: value }
    });
  };
  const handleChange = e => {
    dispatch({
      type: "INPUT_CHANGE",
      payload: { [e.target.name]: e.target.value }
    });
  };
  const handleSubmit = e => {
    e.preventDefault();
    dispatch({ type: "SUBMIT" });
    callback(state.input);
  };

  useEffect(() => {
    if (
      Object.values(state.validationErrs).find(err => err.length) &&
      state.isSubmiting
    )
      dispatch({ type: "STOP_SUBMIT" });
    if (
      !Object.values(state.validationErrs).find(err => err.length) &&
      state.isSubmiting
    )
      callback(state.input); // submit logic
  }, [state.isSubmiting]);

  return { state, handleChange, handleSubmit, OnLoadForm };
};

export default useForm;

// Validation functions
function validateOnSubmit(state) {
  const { input } = state;
  let validationErrs = {};
  if (!input.username) validationErrs.username = "E-mail address is required";
  else if (!/\S+@\S+\.\S+/.test(input.username))
    validationErrs.username = "Should be an E-mail address";
  if (!input.password) validationErrs.password = "Password is required";
  else if (input.password.length < 5)
    validationErrs.password = "Password must be at least 5 characters";
  return validationErrs;
}

function validateOnTouch(state, action) {

    let validationErr = {};
    for (let keyName in action.payload) {
      if(state.input[keyName] !== '') {
        if (state.input[keyName].length > 0 && action.payload[keyName].length === 0)
          validationErr[keyName] = "This field is required";
        if (state.input[keyName].length === 0 && action.payload[keyName].length > 0)
          validationErr[keyName] = "";
      }
    }
    return validationErr;

}
